import {NgModule} from "@angular/core";
import {Route, RouterModule, Routes} from "@angular/router";
import {AcSubRoutes} from "./ac/ac.route";
import {CfSubRoutes} from "./cf/cf.route";
import {CsSubRoutes} from "./cs/cs.route";


export function getRouters(): { name: string; routeMethod: () => Routes }[] {
    return [
        {name : "ac", routeMethod: AcSubRoutes },
        {name : "cf", routeMethod: CfSubRoutes },
        {name : "cs", routeMethod: CsSubRoutes },
    ];
}

function collectSubRoutes(): Route[] {
    const routes: Route[] = [];
    const crmRouters = getRouters();
    for (const router of crmRouters) {
        const subRoutes = router.routeMethod();
        if (subRoutes) {
            routes.push(...subRoutes);
        }
    }
    return routes;
}

const routes: Routes = [
    {
        path: '',
        children: collectSubRoutes(),
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)], // ✅ forChild for lazy module
    exports: [RouterModule],
})
export class FeatureMiscRoutingModule {}
